import Browser from '@wetransfer/concorde-browser';

import StaticPage from '@component/panel/content';

function lazyLoadImage(image) {
  return new Promise((resolve, reject) => {
    image.src = image.dataset.src;
    image.onload = () => resolve(image);
    image.onerror = reject;
  });
}

StaticPage.configure('/about', async (instance) => {
  // We want to be updated with store updates
  instance.subscribeToStore = true;

  const animatingClassName = 'about-carousel__list--sliding';
  const loadedClassName = 'about-carousel__list--loaded';

  const container = instance.node.querySelector('.about-carousel__list');
  const containerImages = instance.node.querySelectorAll(
    '.about-carousel__list img'
  );
  const clonables = instance.node.querySelectorAll('.about-carousel__item');

  await Promise.all(Array.from(containerImages).map(lazyLoadImage));

  if (!container.classList.contains(animatingClassName) && !Browser.isMobile) {
    clonables.forEach((node) => container.appendChild(node.cloneNode(true)));
    container.classList.add(animatingClassName);
  } else {
    let containerWidth = 0;
    clonables.forEach((node) => (containerWidth += node.clientWidth));
    container.scrollLeft = (containerWidth - window.innerWidth) / 2;
    container.classList.add(loadedClassName);
  }
});
